module.exports = __webpack_public_path__ + "img/dotted-bullet.3d67cf7a.svg";